export default class TabsAccordion {
	constructor(el) {
		this.accordion(el);
		this.tabs(el);
	}

	accordion(el) {
		$(el).on('click', '.sl-tab-header', event => {
			if ($(event.currentTarget).parent().hasClass('active')) {
				$('.sl-tab-content').removeClass('active');
			} else {
				$('.sl-tab-content').removeClass('active');
				const content = $(event.currentTarget).parents('.sl-tab-content');
				content.addClass('active');
				$('.sl-nav li').removeClass('active');
				$('.sl-nav li[data-tab="' + content.attr('id') + '"]').addClass('active');
			}
		});
	}

	tabs(el) {
		$(el).on('click', '.sl-nav li', event => {
			const tab = $(event.currentTarget);
			if (!tab.hasClass('active')) {
				$('.sl-nav li, .sl-tab-content').removeClass('active');
				tab.addClass('active');
				$('#' + tab.data('tab')).addClass('active');
			}
		});
	}
}
